export const crosswordRoutes = {
    main: {
        route: '/crosswords',
        get: () => `/crosswords`,
    },
    crossword: {
        main: {
            route: '/crosswords/:number',
            get: (crossword_number) => {
                return `/crosswords/${crossword_number}`;
            },
        },
    },
    search: {
        main: {
            route: '/crosswords/search',
            get: (text) => (text ? `/crosswords/search?q=${text}` : `/crosswords/search`),
        },
    },
    series: {
        series: {
            route: '/crosswords/series/:slug',
            get: (slug) => `/crosswords/series/${slug}`,
        },
    },
    categories: {
        category: {
            route: '/crosswords/categories/:type',
            get: (type) => `/crosswords/categories/${type}`,
        },
    },
    saved: {
        main: {
            route: '/crosswords/saved',
            get: () => '/crosswords/saved',
        },
    },
    notFound: {
        route: '/crosswords/notFound',
        get: () => `/crosswords/notFound`,
    },
};
//# sourceMappingURL=crosswords.js.map